export default "__VITE_ASSET__Cr6vau9L__"